import type { CSSProperties } from 'react'

export function resolveSpacing(spacing: number | undefined): CSSProperties {
  if (spacing === undefined) {
    return {}
  }

  return { gap: `${spacing}px` }
}
